module.exports = __webpack_public_path__ + "img/ruletopimg.92c5d139.png";